<template>
  <Modal :title="title" :show-modal="showModal" @close="$emit('on-close')">
    <section
      class="flex justify-center w-full h-32"
      :class="
        detailLeave.overtime_hr.status === 'Pending'
          ? 'pending'
          : detailLeave.overtime_hr.status === 'Approved'
          ? 'approved'
          : 'not-approved'
      "
    >
      <div
        class="flex items-center justify-center w-10 h-10 p-2 bg-gray-100 rounded-full bg-icon"
      >
        <font-awesome-icon
          icon="fa-check"
          class="text-xl"
          v-if="detailLeave.overtime_hr.status === 'Approved'"
        />
        <font-awesome-icon
          icon="fa-xmark"
          class="text-xl"
          v-else-if="detailLeave.overtime_hr.status === 'Rejected'"
        />
        <font-awesome-icon icon="fa-clock" class="text-xl" v-else />
      </div>
      <section class="relative h-full px-10 ml-10 border-l-2">
        <div
          class="absolute top-0 w-3 h-3 p-2 bg-gray-100 rounded-full indicator -left-2"
        ></div>
        <div class="px-4 py-2 text-gray-400 bg-gray-100 rounded w-52">
          <p class="flex items-center text-sm">Approve HR</p>
        </div>
      </section>
    </section>
    <section
      class="flex justify-center w-full h-32"
      :class="
        detailLeave.overtime_fsuperior?.status === 'Pending'
          ? 'pending'
          : detailLeave.overtime_fsuperior?.status === 'Approved'
          ? 'approved'
          : 'not-approved'
      "
    >
      <div
        class="flex items-center justify-center w-10 h-10 p-2 bg-gray-100 rounded-full bg-icon"
      >
        <font-awesome-icon
          icon="fa-check"
          class="text-xl"
          v-if="detailLeave.overtime_fsuperior?.status === 'Approved'"
        />
        <font-awesome-icon
          icon="fa-xmark"
          class="text-xl"
          v-else-if="detailLeave.overtime_fsuperior?.status === 'Rejected'"
        />
        <font-awesome-icon icon="fa-clock" class="text-xl" v-else />
      </div>
      <section class="relative h-full px-10 ml-10 border-l-2">
        <div
          class="absolute top-0 w-3 h-3 p-2 bg-gray-100 rounded-full indicator -left-2"
        ></div>
        <div class="px-4 py-2 text-gray-400 bg-gray-100 rounded w-52">
          <p class="flex items-center text-sm">Approve Atasan 1</p>
        </div>
      </section>
    </section>
    <section
      class="flex justify-center w-full h-32"
      :class="
        detailLeave.overtime_ssuperior?.status === 'Pending'
          ? 'pending'
          : detailLeave.overtime_ssuperior?.status === 'Approved'
          ? 'approved'
          : 'not-approved'
      "
    >
      <div
        class="flex items-center justify-center w-10 h-10 p-2 rounded-full bg-icon"
      >
        <font-awesome-icon
          icon="fa-check"
          class="text-xl"
          v-if="detailLeave.overtime_ssuperior?.status === 'Approved'"
        />
        <font-awesome-icon
          icon="fa-xmark"
          class="text-xl"
          v-else-if="detailLeave.overtime_ssuperior?.status === 'Rejected'"
        />
        <font-awesome-icon icon="fa-clock" class="text-xl" v-else />
      </div>
      <section class="relative h-full px-10 ml-10 border-l-2">
        <div
          class="absolute top-0 w-3 h-3 p-2 bg-gray-100 rounded-full indicator -left-2"
        ></div>
        <div class="px-4 py-2 text-gray-400 bg-gray-100 rounded w-52">
          <p class="flex items-center text-sm">Approve Atasan 2</p>
          <!-- <p class="mt-1 text-sm">01 Dec, 22</p> -->
        </div>
      </section>
    </section>
    <section class="flex items-center justify-between mt-4">
      <p class="text-sm">HR Response</p>
      <div class="flex md:px-16">
        <Radio
          label="Pending"
          @change="($event) => $emit('on-update-hr-status', $event)"
          :checked="detailLeave.overtime_hr.status === 'Pending'"
          :modelValue="detailLeave.overtime_hr.status"
          value="Pending"
          name="hr_status"
        />
        <Radio
          label="Approved"
          class="mx-8"
          @change="($event) => $emit('on-update-hr-status', $event)"
          :checked="detailLeave.overtime_hr.status === 'Approved'"
          :modelValue="detailLeave.overtime_hr.status"
          name="hr_status"
          value="Approved"
        />
        <Radio
          label="Rejected"
          @change="($event) => $emit('on-update-hr-status', $event)"
          :checked="detailLeave.overtime_hr.status === 'Rejected'"
          :modelValue="detailLeave.overtime_hr.status"
          name="hr_status"
          value="Rejected"
        />
      </div>
    </section>
    <section class="flex items-center justify-between mt-4">
      <p class="text-sm">
        {{ detailLeave.overtime_fsuperior?.fsuperior_id?.des_name }} Response
      </p>
      <div class="flex md:px-16">
        <Radio
          label="Pending"
          @change="($event) => $emit('on-update-fsuperior-status', $event)"
          :checked="detailLeave.overtime_fsuperior.status === 'Pending'"
          :modelValue="detailLeave.overtime_fsuperior.status"
          value="Pending"
          name="fs_status"
        />
        <Radio
          label="Approved"
          class="mx-8"
          @change="($event) => $emit('on-update-fsuperior-status', $event)"
          :checked="detailLeave.overtime_fsuperior.status === 'Approved'"
          :modelValue="detailLeave.overtime_fsuperior.status"
          value="Approved"
          name="fs_status"
        />
        <Radio
          label="Rejected"
          @change="($event) => $emit('on-update-fsuperior-status', $event)"
          :checked="detailLeave.overtime_fsuperior.status === 'Rejected'"
          :modelValue="detailLeave.overtime_fsuperior.status"
          value="Rejected"
          name="fs_status"
        />
      </div>
    </section>
    <section class="flex items-center justify-between mt-4">
      <p class="text-sm">
        {{ detailLeave.overtime_ssuperior?.ssuperior_id?.des_name }} Response
      </p>
      <div class="flex md:px-16">
        <Radio
          label="Pending"
          @change="($event) => $emit('on-update-ssuperior-status', $event)"
          :checked="detailLeave.overtime_ssuperior?.status === 'Pending'"
          :modelValue="detailLeave.overtime_ssuperior?.status"
          value="Pending"
          name="ss_status"
        />
        <Radio
          label="Approved"
          class="mx-8"
          @change="($event) => $emit('on-update-ssuperior-status', $event)"
          :checked="detailLeave.overtime_ssuperior?.status === 'Approved'"
          :modelValue="detailLeave.overtime_ssuperior?.status"
          value="Approved"
          name="ss_status"
        />
        <Radio
          label="Rejected"
          @change="($event) => $emit('on-update-ssuperior-status', $event)"
          :checked="detailLeave.overtime_ssuperior?.status === 'Rejected'"
          :modelValue="detailLeave.overtime_ssuperior?.status"
          value="Rejected"
          name="ss_status"
        />
      </div>
    </section>
    <template #footer>
      <section class="flex justify-between w-52">
        <Button
          class="w-24 py-2 text-white bg-gray-400 rounded-md"
          @click="$emit('on-close')"
        >
          Cancel
        </Button>
        <Button
          class="w-24 py-2 text-white bg-green-500 rounded-md"
          @click="onEditOvertimeRequest"
        >
          Save
        </Button>
      </section>
    </template>
  </Modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import Radio from "@/components/Radio.vue";
import { getDate } from "@/utils/getDate";
import { getCurrentTime } from "@/utils/getHours";

export default {
  name: "ModalNotLeave",
  components: {
    Modal,
    Radio,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    showModal: {
      type: String,
      required: true,
    },
    detailLeave: {
      type: Object,
      required: true,
    },
    typeModal: {
      type: String,
      required: true,
    },
  },
  methods: {
    onEditOvertimeRequest() {
      const payload = {
        overtime_hr: {
          approved_by: "HR / Admin App",
          approved_date: getDate(),
          approved_hours: getCurrentTime(),
          status: this.detailLeave.overtime_hr.status,
        },
        overtime_fsuperior: {
          approved_by: "HR / Admin App",
          approved_date: getDate(),
          approved_hours: getCurrentTime(),
          status: this.detailLeave.overtime_fsuperior.status,
        },
        overtime_ssuperior: {
          approved_by: "HR / Admin App",
          approved_date: getDate(),
          approved_hours: getCurrentTime(),
          status: this.detailLeave.overtime_ssuperior.status,
        },
      };
      this.$emit("on-approval-employee", {
        id: this.detailLeave._id,
        payload,
        type: this.typeModal,
      });
    },
  },
};
</script>
